import script from "./CustomNodeEnd.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomNodeEnd.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./CustomNodeEnd.vue?vue&type=custom&index=0&blockType=style2"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__